import { render, staticRenderFns } from "./AttentionsByTypeItem.vue?vue&type=template&id=6c74c9f0&scoped=true&"
import script from "./AttentionsByTypeItem.vue?vue&type=script&lang=js&"
export * from "./AttentionsByTypeItem.vue?vue&type=script&lang=js&"
import style0 from "./AttentionsByTypeItem.vue?vue&type=style&index=0&id=6c74c9f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c74c9f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6c74c9f0', component.options)
    } else {
      api.reload('6c74c9f0', component.options)
    }
    module.hot.accept("./AttentionsByTypeItem.vue?vue&type=template&id=6c74c9f0&scoped=true&", function () {
      api.rerender('6c74c9f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base/AttentionsByTypeItem.vue"
export default component.exports